import React from 'react';
import { ROUTES } from 'routing/constants';
import { ReactComponent as CongratsIcon } from 'assets/svg/congrats.svg';
import Button from 'components/Button';
import { StyledCongratsWrapper, StyledCongrats } from './Congratulations.style';

const Congratulations = () => (
    <StyledCongratsWrapper>
        <StyledCongrats>
            <CongratsIcon />
            <strong>Congratulations!</strong>
            <span>
                You’re all caught-up. Use the button below to see all assigned
                and completed Smart Tips.
            </span>
            <Button to={ROUTES.smartTips} primaryDark>
                View All Assigned Smart Tips
            </Button>
        </StyledCongrats>
    </StyledCongratsWrapper>
);

export default Congratulations;
